export enum CMDTYPE {
  FAQ_LIST = '010000',
  NOTICE_NEWS_LIST = '010012',
  NEWS_LIST = '010013',
  NOTICE_LIST = '010002',
  NOTICE_ITEM = '010003',
  TERMS_LIST = '010005',
  REFUND_TERMS = '010015',
  REGISTER_CENTER_QNA = '010001',
  REQUEST_CAPTCHA = '010010',
  CANCEL_VERIFY_CAPTCHA = '010011',
  SERVICE_CANCEL = '010007',
  REFUND_VERIFY_CAPTCHA = '010018',
  SERVICE_REFUND = '010019',
}
